import moment from "moment";
import React, { useState } from "react";
import { formattedAmount } from "../../../utils/helpers/Functions.helper";
import { DeliveryManApis } from "../../../apis/delivery.apis";
import { toast } from "react-toastify";

const AssignOrderModal = ({
  isAssignModal,
  setIsAssignModal,
  itemData,
  allDeliveryMan,
}) => {
  const [showManualAssign, setShowManualAssign] = useState(false);
  const [isDeliveryManID, setDeliveryManID] = useState("");

  console.log("itemData:", itemData);

  const handleManualAssign = async (isDeliveryManID) => {
    const value = {
      customer_order_id: itemData?.order_id || null,
      deliveryPersonnelId: isDeliveryManID || null,
    };
    console.log("value:", value);
    try {
      const res = await DeliveryManApis.assignDeliveryMan(value);
      console.log("response:", res?.data?.data);
      toast.success(res.message);
    } catch (err) {
      toast.error("error:", err);
    } finally {
      setIsAssignModal();
      setShowManualAssign();
      setDeliveryManID();
    }
  };

  return (
    <div className="w-full fixed inset-0 flex items-center justify-center bg-[#111827d9] bg-opacity-80 z-[9999]">
      <div className="bg-white rounded-lg shadow-lg p-4 w-full max-w-md z-40">
        {/* Header */}
        <div className="flex justify-between items-center cursor-pointer">
          <h1 className="text-xl font-bold">Assign Order</h1>
          <div
            onClick={() => setIsAssignModal(false)}
            className="text-xl font-bold hover:text-black"
          >
            X
          </div>
        </div>
        <hr className="my-4" />

        {showManualAssign ? (
          <div>
            {/* Manual Assign Section */}
            <h2 className="text-lg font-semibold">Select Delivery Personnel</h2>
            <div className="space-y-2 mt-2">
              {allDeliveryMan?.map((person) => (
                <label
                  key={person?.userId}
                  className="flex items-center space-x-2"
                >
                  <input
                    type="radio"
                    name="deliveryPerson"
                    value={person?._id}
                    className="form-radio"
                    onClick={() => setDeliveryManID(person?._id)}
                  />
                  <span>
                    {person?.firstName} {person?.lastName}
                  </span>
                </label>
              ))}
            </div>
          </div>
          // <div>
          //   {/* Manual Assign Section */}
          //   <h2 className="text-lg font-semibold">Work in Progress</h2>
          //   <div className="space-y-2 mt-2">
          //     <p>Third Party Delivery-app integration is pending by Admin</p>
          //   </div>
          // </div>
        ) : (
          <div>
            {/* Order Details Section */}
            <div className="space-y-2">
              <p>
                <strong>Order ID:</strong> {itemData?.order_id}
              </p>
              <p>
                <strong>Order Type:</strong> {itemData?.order_type}
              </p>
              <p>
                <strong>No of Orders:</strong> {itemData?.orderDetails?.length}
              </p>
              <p>
                <strong>Order Date:</strong>{" "}
                {moment(itemData.order_date).format("MMM Do, YYYY")}
              </p>
              <p>
                <strong>Delivery Address:</strong>{" "}
                {itemData.delivery_address.street},
                {itemData.delivery_address.city.name},{" "}
                {itemData.delivery_address.country.name}
              </p>
              <p>
                <strong>Order Cost:</strong>{" "}
                {formattedAmount(itemData?.net_total?.$numberDecimal)}
              </p>
              <p>
                <strong>Payment Status:</strong> {itemData?.payment_status}
              </p>
              <p className="pt-4 font-bold">Vendor Contacts</p>
              <hr className="p-0 m-0" />
              <p>
                <strong>Shop Name:</strong>{" "}
                {itemData.orderDetails[0].vendor.first_name}
              </p>
              <p>
                <strong>Contact No:</strong>{" "}
                {itemData.orderDetails[0].vendor.phone_number}
              </p>
              <p>
                <strong>Contact Email:</strong>{" "}
                {itemData.orderDetails[0].vendor.email}
              </p>
              <p className="pt-4 font-bold">Customer Contacts</p>
              <hr />
              <p>
                <strong>Ordered By:</strong> {itemData.delivery_address.name}
              </p>
              <p>
                <strong>Contact No:</strong>{" "}
                {itemData.delivery_address.phone_number}
              </p>
            </div>
          </div>
        )}

        {/* Button Section */}
        <div className="mt-6 flex justify-center gap-2">
          {showManualAssign ? (
            <>
              <button
                className="bg-gray500 text-white px-4 py-2 rounded hover:bg-gray600"
                onClick={() => setShowManualAssign(false)}
              >
                Back
              </button>
              {/* <button
                className="bg-green500 text-white px-4 py-2 rounded hover:bg-green600"
                onClick={() => setIsAssignModal(false)}
              >
                Ok
              </button> */}
              <button
                className="bg-green500 text-white px-4 py-2 rounded hover:bg-green600"
                onClick={() => handleManualAssign(isDeliveryManID)}
              >
                Assign Selected
              </button>
            </>
          ) : (
            <>
              <button
                className="bg-green500 text-white px-4 py-2 rounded hover:bg-green600"
                onClick={() => alert("we are working on auto assign")}
              >
                Auto Assign
              </button>
              <button
                className="bg-red500 text-white px-4 py-2 rounded hover:bg-red600"
                onClick={() => setShowManualAssign(true)}
              >
                Manual Assign
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignOrderModal;
